import React, { useEffect, useState } from "react";
import { Image, Header, Label } from "semantic-ui-react";
import DataTable from "react-data-table-component";
import Moment from "react-moment";
import { useLocation, useHistory } from "react-router";
import { checkIsActive } from "../../../_metronic/_helpers";
import Add from "./add";
import Edit from "./edit";
import Preview from "./preview/index";
import Filters from "./filters";
import { useDispatch, useSelector, connect } from "react-redux";
import { selectTranslations } from "../../config/i18n/slice";
import { usePermissionsSimplified } from "../../../hooks/usePermissionsSimplified";
import { LetteredAvatarImageUrl } from "../../components/common/userProfilePlaceholder";
import useDisplayFormattedText from "../../../hooks/useDisplayFormattedText";
import useGetCurrentTimeAccZone from "../../../hooks/useGetCurrentTimeAccZone";
import * as auth from "../../modules/Auth/_redux/authRedux";
import {
  ArrowLeft,
  ArrowRight,
  CloseIcon,
  PartIcon,
  PlusIcon,
  PurchaseBlueIcon,
  SortIcon,
} from "../../../Assets/Icons/svg";
import Pagination from "../../components/common/CommonPagination";
import ToolTip from "react-power-tooltip";
import { useDebounce } from "use-debounce";
import {
  fetchAllPOData,
  fetchPOInitData,
  fetchPOWithFilter,
} from "../../../redux/reducers/purchaseOrderReducer";
import Animation from "../../components/common/CustomLoader";
import { currencyDecimalPlaces } from "../../config/common/commonVariables";
import { getUserData } from "../../config/sharedApi/peopleApis";
import { humanize } from "../../config/common/commonFunctions";

const customStyles = {
  headCells: {
    style: {
      paddingTop: "11px",
    },
  },
  cells: {
    style: {
      paddingLeft: "16px",
      paddingRight: "16px",
      paddingTop: "19px",
      paddingBottom: "19px",
    },
  },
};

/*
 * The `PurchaseOrder` function in JavaScript is a component that handles the display and management of
 * purchase orders, including filtering, sorting, pagination, and modals for adding, editing, and previewing purchase orders.
 */
const PurchaseOrder = (props) => {
  const { userPermissions } = usePermissionsSimplified();
  const dispatch = useDispatch();

  const [modalWidth, setModalWidth] = useState(
    Math.max(window.innerWidth / 2, 514)
  );

  const organisationCurrency = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.currency;
    } else {
      return "JOD";
    }
  });

  const user = useSelector((state) => {
    if (state?.auth?.user) {
      return state.auth.user;
    } else {
      return null;
    }
  });

  const currentUserLocations = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.locations;
    } else {
      return null;
    }
  });

  const role = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.role.type;
    } else {
      return null;
    }
  });

  const allIds = [];

  currentUserLocations?.length &&
    currentUserLocations.forEach((location) => {
      if (!allIds.some((inv) => inv == location?.id)) {
        allIds.push(location?.id);
      }
    });

  /*
   * The handleDecimalPoints function formats a numerical value to a specified number of decimal places and removes trailing zeros after the decimal point.
   */
  const handleDecimalPoints = (value) => {
    const decimalPlaces = currencyDecimalPlaces[organisationCurrency] ?? 2; // Default to 2 if currency not found
    const factor = Math.pow(10, decimalPlaces);
    const truncatedValue = Math.trunc(value * factor) / factor;
    const formattedValue = truncatedValue.toFixed(decimalPlaces);

    // Remove trailing zeros after the decimal point
    if (formattedValue.indexOf(".") !== -1) {
      return formattedValue.replace(/\.?0+$/, "");
    }

    return formattedValue;
  };

  const [loadUserData, setLoadUserData] = useState(false);
  const { DisplayFormattedText } = useDisplayFormattedText();
  const t = useSelector(selectTranslations);
  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const [filterOptions, setFilterOptions] = useState({
    vendors: [],
    totalCost: {
      from: null,
      to: null,
    },
    status: [],
  });

  const [selectedDates, setSelectedDates] = useState([]);
  const [dueDates, setDueDates] = useState([]);

  const curentUrl = useLocation();
  const queryParams = new URLSearchParams(curentUrl.search);
  const partId = queryParams.get("id");
  const history = useHistory();

  const [toggleAsideModal, setToggleAsideModal] = useState(false);
  const [sortData, setSortData] = useState();
  const [fetching, setFetchLoading] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);
  const [targetedData, setTargetedData] = useState();
  const [loader, setloader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [togglePreview, setTogglePreviw] = useState(false);
  const [toggleEditModal, setToggleEditModal] = useState(false);

  const statusOptions = [
    {
      value: "requested",
      color: "yellow",
      label: t.po.status.requested,
    },
    {
      value: "approved",
      color: "green",
      label: t.po.status.approved,
    },
    {
      value: "declined",
      color: "red",
      label: t.po.status.declined,
    },
    {
      value: "fulfilled",
      color: "black",
      label: t.po.status.fulfilled,
    },
    {
      value: "partiallyfulfilled",
      color: "blue",
      label: t.po.status.partially_fulfilled,
    },
    {
      value: "cancelled",
      color: "darkgrey",
      label: t.po.status.cancelled,
    },
  ];

  const location = useLocation();

  /*
   * The handleSort function sets sorting parameters, fetches data with filters and sorting, and updates the loader state accordingly.
   */
  const handleSort = async (column, sortDirection) => {
    setloader(true);
    const sort = [`${column.sortField}:${sortDirection}`];
    setSortData(sort);
    const sortedData = await dispatch(
      fetchPOWithFilter({
        organisationId,
        searchName: debounceValue,
        page: page,
        pageSize: pageSize,
        vendors: filterOptions.vendors,
        status: filterOptions.status,
        totalCost: filterOptions.totalCost,
        submissionDate: selectedDates,
        dueDate: dueDates,
        sort: sort,
        role,
        allIds,
      })
    );

    setloader(false);
  };

  /* The function `handleRemoveSorting` for remove sorts data */
  const handleRemoveSorting = async () => {
    setloader(true);

    // Assuming the select or represents the field to sort
    const sort = undefined;
    setSortData(sort);
    const sortedData = await dispatch(
      fetchPOWithFilter({
        organisationId,
        searchName: debounceValue,
        page: page,
        pageSize: pageSize,
        vendors: filterOptions.vendors,
        status: filterOptions.status,
        totalCost: filterOptions.totalCost,
        submissionDate: selectedDates,
        dueDate: dueDates,
        sort: sort,
        role,
        allIds,
      })
    );

    setloader(false);
  };

  const {
    data,
    isLoading: loading,
    error,
    initData,
    page,
    pageSize,
    total,
    initLoading,
  } = useSelector((state) => ({
    data: state.purchaseOrder.POData,
    isLoading: state.purchaseOrder.isLoading,
    error: state.purchaseOrder.error,
    initData: state.purchaseOrder.POInitData,
    page: state.purchaseOrder.page,
    pageSize: state.purchaseOrder.pageSize,
    total: state.purchaseOrder.total,
    initLoading: state.purchaseOrder.initLoading,
  }));

  /* The above code is setting the data by fetching it from a source using the `fetchData`
  function. */
  useEffect(() => {
    const fetchData = async () => {
      setLoadUserData(true);
      if (!(role === "super_admin")) {
        const userData = await getUserData(user.id);

        dispatch(props.fulfillUser(userData));
      }
      const fetchData = await dispatch(
        fetchPOInitData({ organisationId, role, allIds })
      );
      setLoadUserData(false);
      if (fetchData) {
        setFetchLoading(false);
        if (partId) {
          if (partId == "true") {
            setToggleAsideModal(true);
          } else {
            const fetchAllData = await dispatch(
              fetchAllPOData({ organisationId, role, allIds })
            );

            let selectedPart = fetchAllData.payload.response.find(
              (each) => each.attributes?.countId == partId
            );
            if (selectedPart) {
              setTargetedData(selectedPart);
              setTogglePreviw(true);
            }
          }
        }
      }
    };

    fetchData();
  }, [partId]);

  const [searchTitle, setSearchTitle] = useState("");
  const [debounceValue] = useDebounce(searchTitle, 500);
  const [debounceRate] = useDebounce(filterOptions.totalCost, 500);

  /* The above code is defining an array of column configurations for a table. Each object in the
`columns` array represents a column in the table with properties such as `name`, `sortField`,
`sortable`, `minWidth`, and `cell` function to render the content of the cell. */
  const columns = [
    {
      width: selectedLanguage === "en" ? "113px" : "107px",
      name: t.assets.table.ID,
      sortField: "countNumId",
      sortable: true,
      cell: (row) => (
        <span
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
          className="id-text-style"
        >
          {row?.attributes?.countId}
        </span>
      ),
    },
    {
      name: t.workOrders.table.title,
      sortField: "details.title",
      sortable: true,
      minWidth: "165px",

      cell: (row) => (
        <span
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
          className="id-text-style"
        >
          {row?.attributes?.details?.title
            ? DisplayFormattedText(
                humanize(row?.attributes?.details?.title),
                14
              )
            : t.common.na}
        </span>
      ),
    },

    {
      name: t.po.table.po_number,
      sortField: "details.poNumber",
      sortable: true,
      minWidth: selectedLanguage == "en" ? "144px" : "170px",

      cell: (row) => (
        <span
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
          className=""
        >
          {row?.attributes?.details?.poNumber
            ? row?.attributes?.details?.poNumber
            : t.common.na}
        </span>
      ),
    },

    {
      minWidth: "170px",
      sortField: "status",
      name: t.workOrders.table.status,

      sortable: true,
      cell: (row) => {
        const workOrderStatus = statusOptions.find(
          (status) => status.value === row.attributes.status
        );

        return (
          <div
            onClick={() => {
              setTargetedData(row);
              setTogglePreviw(true);
            }}
            className="d-flex align-items-center"
          >
            <Label
              circular
              empty
              color={workOrderStatus?.color || "#788ca5"}
              medium
            />
            <div>
              <span className="ml-2 mr-2">
                {workOrderStatus?.label || t.common.na}
              </span>
            </div>
          </div>
        );
      },
    },

    {
      minWidth: selectedLanguage === "en" ? "134px" : "144px",
      sortField: "details.vendor.name",
      name: t.po.table.vendor,
      sortable: true,
      cell: (row) => (
        <span
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
          className="id-text-style"
        >
          {row?.attributes?.details?.vendor?.data?.attributes?.name
            ? DisplayFormattedText(
                humanize(
                  row?.attributes?.details?.vendor?.data?.attributes?.name
                ),
                12
              )
            : t.common.na}
        </span>
      ),
    },

    {
      name: t.po.table.no_items,
      sortField: "totalItems",
      sortable: true,
      minWidth: "143px",

      cell: (row) => (
        <span
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
          className=""
        >
          {row?.attributes?.totalItems ? row?.attributes?.totalItems : "0"}
        </span>
      ),
    },

    {
      name: t.po.table.total_qty,
      sortField: "totalQty",
      sortable: true,
      minWidth: selectedLanguage == "en" ? "140px" : "160px",

      cell: (row) => (
        <span
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
          className=""
        >
          {row?.attributes?.totalQty ? row?.attributes?.totalQty : "0"}
        </span>
      ),
    },
    {
      name: t.po.table.total_cost,
      sortField: "orderItems.totalCost",
      sortable: true,
      minWidth: selectedLanguage == "en" ? "140px" : "162px",

      cell: (row) => (
        <span
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
          className=""
        >
          {row?.attributes?.orderItems?.totalCost
            ? handleDecimalPoints(row?.attributes?.orderItems?.totalCost)
            : "0"}{" "}
          {organisationCurrency}
        </span>
      ),
    },
    {
      name: t.po.table.due_date,
      sortField: "details.dueDate",
      sortable: true,
      minWidth: selectedLanguage === "en" ? "144px" : "171px",
      cell: (row) => (
        <div
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
        >
          <div>
            <Moment
              format="DD/MM/YYYY"
              date={row?.attributes?.details?.dueDate}
            />
          </div>
          <div className="time-text-style text-left">
            <Moment format="LT" date={row?.attributes?.details?.dueDate} />
          </div>
        </div>
      ),
    },

    {
      name: t.parts.table.created_on,
      sortField: "createdAt",
      sortable: true,
      minWidth: "144px",
      cell: (row) => (
        <div
          onClick={() => {
            setTargetedData(row);
            setTogglePreviw(true);
          }}
        >
          <div>
            <Moment format="DD/MM/YYYY" date={row?.attributes?.createdAt} />
          </div>
          <div className="time-text-style text-left">
            <Moment format="LT" date={row?.attributes?.createdAt} />
          </div>
        </div>
      ),
    },

    {
      name: t.procedures.table.createdByUser,
      sortField: "createdByUser",
      sortable: true,
      minWidth: selectedLanguage === "en" ? "144px" : "164px",
      cell: (row) => {
        let createdByUser = row?.attributes?.createdByUser?.data ? (
          <div>
            <Image
              avatar
              title={
                row.attributes.createdByUser?.data?.attributes?.firstName +
                " " +
                row.attributes.createdByUser?.data?.attributes?.lastName
              }
              src={
                row?.attributes?.createdByUser?.data?.attributes?.profileImage
                  ?.data?.attributes?.url
                  ? row?.attributes?.createdByUser?.data?.attributes
                      ?.profileImage?.data?.attributes?.url
                  : LetteredAvatarImageUrl(
                      row?.attributes?.createdByUser?.data?.attributes
                        .firstName +
                        " " +
                        row?.attributes?.createdByUser?.data?.attributes
                          ?.lastName
                    )
              }
              className="submitted-avatar"
             
            />
          </div>
        ) : (
          t.common.na
        );
        return (
          <span
            onClick={() => {
              setTargetedData(row);
              setTogglePreviw(true);
            }}
            className="ml-1 mr-1"
          >
            {createdByUser}
          </span>
        );
      },
    },

    {
      name: t.po.table.approved_by,
      sortField: "approvedByUser",
      sortable: true,
      minWidth: selectedLanguage === "en" ? "148px" : "204px",
      cell: (row) => {
        let createdByUser = row?.attributes?.approvedByUser?.data ? (
          <div>
            <Image
              avatar
              title={
                row.attributes.approvedByUser?.data?.attributes?.firstName +
                " " +
                row.attributes.approvedByUser?.data?.attributes?.lastName
              }
              src={
                row?.attributes?.approvedByUser?.data?.attributes?.profileImage
                  ?.data?.attributes?.url
                  ? row?.attributes?.approvedByUser?.data?.attributes
                      ?.profileImage?.data?.attributes?.url
                  : LetteredAvatarImageUrl(
                      row?.attributes?.approvedByUser?.data?.attributes
                        .firstName +
                        " " +
                        row?.attributes?.approvedByUser?.data?.attributes
                          ?.lastName
                    )
              }
              className="submitted-avatar"
             
            />
          </div>
        ) : (
          t.common.na
        );
        return (
          <span
            onClick={() => {
              setTargetedData(row);
              setTogglePreviw(true);
            }}
            className="ml-1 mr-1"
          >
            {createdByUser}
          </span>
        );
      },
    },
  ];

  const handleSetDataByFilter = (newData) => {
    // setData(newData);
  };
  /*
   * The function `getPaginatedData` takes an array of data and returns a paginated subset based on the current page and page size.
   */
  const getPaginatedData = (dataToPaginate) => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return dataToPaginate.slice(startIndex, endIndex);
  };
  const totalFilteredPages = Math.ceil(data.length / pageSize);
  return (
    <>
      <div className="new-listing-container table-header-dashboard stick-header pb-5">
        <div className="header-actions">
          <Header className="procedure-title mt-5" as="h2">
            {" "}
            <PartIcon />
            {t.po.title}
          </Header>
          <div></div>

          {userPermissions?.["purchase-order"]?.create &&
          initData?.length > 0 ? (
            <button
              onClick={() => {
                setToggleAsideModal(true);
              }}
              type="button"
              className="add-button po"
            >
              <span className="add-button-text"> {t.po.title_single}</span>
              <span className="add-button-img">
                <PlusIcon />
              </span>
            </button>
          ) : null}
        </div>
        {initData?.length > 0 ? (
          <div className="new-listing-filter wo-filter sticky-filter mt-8">
            <Filters
              data={initData}
              role={role}
              allIds={allIds}
              fileData={data}
              setSortData={setSortData}
              setloader={setloader}
              loader={loader}
              debounceValue={debounceValue}
              setSearchTitle={setSearchTitle}
              searchTitle={searchTitle}
              sortData={sortData}
              setDataByFilter={handleSetDataByFilter}
              hasStatus={false}
              setFilterOptions={setFilterOptions}
              filterOptions={filterOptions}
              setSelectedDates={setSelectedDates}
              selectedDates={selectedDates}
              setDueDates={setDueDates}
              dueDates={dueDates}
              debounceRate={debounceRate}
            />
          </div>
        ) : null}
      </div>
      <div className="new-listing-container">
        {initLoading || loadUserData ? (
          <div
            className="d-flex animation-div justify-content-center align-items-center"
          >
            <Animation />
          </div>
        ) : (
          <div className="new-listing-filter">
            {initData?.length > 0 ? (
              <>
                {error ? (
                  <div className="mt-8 mb-8 ">
                    <Animation />
                  </div>
                ) : (
                  <DataTable
                    className="datatable-div"
                    columns={columns}
                    data={getPaginatedData(data)}
                    onSort={handleSort}
                    fixedHeader
                    customStyles={customStyles}
                    noDataComponent={
                      initData.length > 0 ? (
                        <div className="no-data-container">
                          <div className="">
                            <p className="no-data-text">
                              {t.common.no_result_found}
                            </p>
                          </div>
                        </div>
                      ) : null
                    }
                    direction={selectedLanguage === "en" ? "ltr" : "rtl"}
                    onRowClicked={(row) => {
                      setTargetedData(row);
                      setTogglePreviw(true);
                    }}
                    sortIcon={
                      sortData ? (
                        <div>
                          <span>
                            <SortIcon />
                          </span>
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveSorting();
                            }}
                          >
                            <CloseIcon />
                          </span>
                        </div>
                      ) : (
                        <span></span>
                      )
                    }
                    persistTableHead={true}
                    pointerOnHover={true}
                    highlightOnHover={true}
                    progressPending={loader}
                    progressComponent={
                      <div className="mt-8 mb-8 ">{t.common.loading}</div>
                    }
                  />
                )}
                <div className="d-flex justify-content-end">
                  <Pagination
                    ofString={t.common.of}
                    total={total}
                    prevItem={
                      selectedLanguage === "en" ? <ArrowLeft /> : <ArrowRight />
                    }
                    nextItem={
                      selectedLanguage === "en" ? <ArrowRight /> : <ArrowLeft />
                    }
                    page={page}
                    limit={pageSize}
                    handleNext={async () => {
                      setloader(true);
                      await dispatch(
                        fetchPOWithFilter({
                          organisationId,
                          searchName: debounceValue,
                          page: page + 1,
                          pageSize: pageSize,
                          vendors: filterOptions.vendors,
                          status: filterOptions.status,
                          totalCost: filterOptions.totalCost,
                          submissionDate: selectedDates,
                          dueDate: dueDates,

                          sort: sortData,
                          role,
                          allIds,
                        })
                      );
                      setloader(false);
                    }}
                    handlePrevious={async () => {
                      setloader(true);
                      await dispatch(
                        fetchPOWithFilter({
                          organisationId,
                          searchName: debounceValue,
                          page: page - 1,
                          pageSize: pageSize,
                          vendors: filterOptions.vendors,
                          status: filterOptions.status,
                          totalCost: filterOptions.totalCost,
                          submissionDate: selectedDates,
                          dueDate: dueDates,
                          sort: sortData,
                          role,
                          allIds,
                        })
                      );
                      setloader(false);
                    }}
                  />
                </div>
              </>
            ) : (
              <div className="">
                <div className="no-data-container">
                  <div className="no-work-orders pb-15">
                    <PurchaseBlueIcon />
                    <p className="no-data-text">
                      {t.common.there_no}{" "}
                      <span
                        className="link-text position-relative c-pointer"
                      
                        onMouseOver={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                      >
                        <ToolTip
                          color="#fff"
                          backgroundColor="#172B4D"
                          position="top left"
                          show={showTooltip}
                          textBoxWidth={
                            selectedLanguage == "ar" ? "170px" : "70px"
                          }
                          arrowAlign="start"
                          fontSize="14px"
                          fontWeight="400"
                          fontFamily={
                            selectedLanguage == "ar"
                              ? "Noto Kufi Arabic"
                              : "Roboto"
                          }
                          padding="0px 0px 0px 8px"
                          borderRadius="5px"
                          static
                          moveRight={
                            selectedLanguage == "ar" ? "40px" : "120px"
                          }
                          moveUp="-1px"
                        >
                          <span className="work-order-tooltip">
                            {t.po.how_to_add}
                          </span>
                        </ToolTip>
                        {" " + t.po.title + " "}
                      </span>{" "}
                      {t.common.added}
                    </p>
                    {userPermissions?.["purchase-order"]?.create ? (
                      <button
                        className="work-order-button-transparent"
                        onClick={() => {
                          setToggleAsideModal(true);
                        }}
                      >
                        {t.po.start_add}
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {toggleAsideModal && (
          <Add
            toggled={toggleAsideModal}
            untoggle={() => {
              setToggleAsideModal(false);
              setModalWidth(Math.max(window.innerWidth / 2, 514));
            }}
            role={role}
            allIds={allIds}
            setListSearchTitle={setSearchTitle}
            setSortData={setSortData}
            setFilterOptions={setFilterOptions}
            filterOptions={filterOptions}
            setDueDates={setDueDates}
            setSearchTitle={setSearchTitle}
            setSelectedDates={setSelectedDates}
          />
        )}
        {togglePreview && (
          <Preview
            targetedData={targetedData}
            role={role}
            allIds={allIds}
            toggled={togglePreview}
            setModalWidth={setModalWidth}
            modalWidth={modalWidth}
            edit={() => {
              setTogglePreviw(false);
              setModalWidth(Math.max(window.innerWidth / 2, 514));
              setToggleEditModal(true);
            }}
            untoggle={() => {
              setTargetedData();
              setModalWidth(Math.max(window.innerWidth / 2, 514));
              setTogglePreviw(false);
              history.push("/purchase-orders");
            }}
            setFilterOptions={setFilterOptions}
            setSelectedDates={setSelectedDates}
            setDueDates={setDueDates}
            setSearchTitle={setSearchTitle}
          />
        )}

        {toggleEditModal && (
          <Edit
            targetedData={targetedData}
            role={role}
            allIds={allIds}
            toggled={toggleEditModal}
            untoggle={() => {
              setTargetedData();
              setToggleEditModal(false);
              setModalWidth(Math.max(window.innerWidth / 2, 514));
            }}
            setFilterOptions={setFilterOptions}
            setSelectedDates={setSelectedDates}
            setDueDates={setDueDates}
          />
        )}
      </div>{" "}
    </>
  );
};

export default connect(null, auth.actions)(PurchaseOrder);
